import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import filterProducts from 'utils/attributes/filterProducts';
import getSpecifiedAttributes from 'utils/attributes/getSpecifiedAttributes';
import sanitiseXSS from 'utils/sanitiseXSS';
import getProductAttributes from '../selector/getProductAttributes';
import getProductItems from '../selector/getProductItems';
import getProductPageSelectors from '../selector/getProductPageSelectors';
import { setInitialProductFlagAction, setProductIdAction } from '../slice';

const selectProductBasedOnUrlParametersOperation =
  () => (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const productPageSelectors = getProductPageSelectors(store);
    const productPageAttributeList = productPageSelectors.map((selector) => selector.typeName);
    const allProductAttributes = getProductAttributes(store);
    let importantProductAttributes = getSpecifiedAttributes(productPageAttributeList, allProductAttributes);

    const urlParams = new URLSearchParams(window.location.search);

    importantProductAttributes = importantProductAttributes.map((attr) => {
      const valueFromUrl = urlParams.get(attr.typeName);
      const newAttr = { ...attr };
      if (valueFromUrl) {
        newAttr.value = sanitiseXSS(valueFromUrl);
      }
      return newAttr;
    });

    const allProducts = getProductItems(store);
    const bestMatchingProducts = filterProducts(allProducts as any[], importantProductAttributes);

    if (!bestMatchingProducts.length) return;

    const { productId } = bestMatchingProducts[0].product;
    dispatch(setProductIdAction(productId));
    dispatch(setInitialProductFlagAction(false));
  };

export default selectProductBasedOnUrlParametersOperation;
